export default "__VITE_ASSET__Du3wP8Ln__"